import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService, ApiModels } from '@mona/api';
import { Encounter, EntryControl } from '@mona/models';
import { transformApiEntryControls } from './transforms';

/**
 * API abstraction layer for the entry controls
 */
@Injectable({
    providedIn: 'root',
})
export class EntryControlsApi {
    apiBase = '/pdms/entry-controls/';

    /**
     * Constructor
     * @param http HttpClient
     */
    constructor(private http: HttpService) {}

    /**
     * Get entry controls
     * @param encounterId
     */
    getEntryControls(encounterId: EntityId<Encounter>): Observable<EntryControl[]> {
        return this.http
            .get<ApiModels.EntryControl[]>(this.apiBase, {
                params: {
                    encounter_id: `${encounterId}`,
                },
            })
            .pipe(map(apiEntryControls => transformApiEntryControls(apiEntryControls)));
    }
}
